module.exports = __webpack_public_path__ + "static/media/2020.8.19垃圾分类主题创意画活动.031d1f75.jpg";